import entity from './entity';
import { getCurrentEmployer } from '../../features/employers/selectors';

// These reads are triggered opportunistically by Dashboard and Settings surfaces. Until
// the planned billing cleanup determines which consumers should remain, a billing-service
// outage must not interrupt unrelated EC2 work with a global toaster. Keep recording the
// failure in Redux and rejecting the thunk so callers retain the same control flow and
// observability; suppress only the user-facing notification.

export const TYPES = {
  GET_CREDIT_CARD_LIST_FAILURE: `${entity.name}/GET_CREDIT_CARD_LIST_FAILURE`,
  GET_CREDIT_CARD_LIST_REQUEST: `${entity.name}/GET_CREDIT_CARD_LIST_REQUEST`,
  GET_CREDIT_CARD_LIST_SUCCESS: `${entity.name}/GET_CREDIT_CARD_LIST_SUCCESS`,

  GET_CARD_SUB_ORGANIZATIONS_FAILURE: `${entity.name}/GET_CARD_SUB_ORGANIZATIONS_FAILURE`,
  GET_CARD_SUB_ORGANIZATIONS_REQUEST: `${entity.name}/GET_CARD_SUB_ORGANIZATIONS_REQUEST`,
  GET_CARD_SUB_ORGANIZATIONS_SUCCESS: `${entity.name}/GET_CARD_SUB_ORGANIZATIONS_SUCCESS`,

  CLEAR_CARDS_LIST: `${entity.name}/CLEAR_CARDS_LIST`,

  GET_DECLINED_TRANSACTIONS_FAILURE: `${entity.name}/GET_DECLINED_TRANSACTIONS_FAILURE`,
  GET_DECLINED_TRANSACTIONS_REQUEST: `${entity.name}/GET_DECLINED_TRANSACTIONS_REQUEST`,
  GET_DECLINED_TRANSACTIONS_SUCCESS: `${entity.name}/GET_DECLINED_TRANSACTIONS_SUCCESS`,
};

export const getCardSubOrganizations = options => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_CARD_SUB_ORGANIZATIONS_REQUEST, payload: { page: options?.page } });
  try {
    const state = getState();
    const orgId = getCurrentEmployer(state);
    const response = await entity.api.getCardSubOrganizations(orgId, options);
    const data = response?.data?.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
    dispatch({ type: TYPES.GET_CARD_SUB_ORGANIZATIONS_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_CARD_SUB_ORGANIZATIONS_FAILURE, payload: error });
    throw error;
  }
};

export const getCreditCardList = (query, options) => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_CREDIT_CARD_LIST_REQUEST, payload: { page: options?.page } });
  try {
    const state = getState();
    const orgId = getCurrentEmployer(state);
    const response = await entity.api.getCreditCardList(orgId, query, options);
    const content = response?.data?.content || [];
    const data = content.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
    dispatch({ type: TYPES.GET_CREDIT_CARD_LIST_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_CREDIT_CARD_LIST_FAILURE, payload: error });
    throw error;
  }
};

export const getDeclinedTransactionsList = (query, options) => async (dispatch) => {
  dispatch({ type: TYPES.GET_DECLINED_TRANSACTIONS_REQUEST, payload: { page: options?.page } });
  try {
    const response = await entity.api.getDeclinedTransactions(query, options);
    const content = response?.data?.content || [];
    const data = content.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
    dispatch({ type: TYPES.GET_DECLINED_TRANSACTIONS_SUCCESS, payload: data });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_DECLINED_TRANSACTIONS_FAILURE, payload: error });
    throw error;
  }
};

export const clearCardsList = () => (dispatch) => {
  dispatch({ type: TYPES.CLEAR_CARDS_LIST });
};

export default {
  TYPES,
  clearCardsList,
  getCardSubOrganizations,
  getCreditCardList,
};
